module.exports = __webpack_public_path__ + "static/media/Slide68.b819830a.JPG";